// extracted by mini-css-extract-plugin
export default {"header":"MotorsTable_header__2u7Re","body":"MotorsTable_body__GSRDy","error":"MotorsTable_error__jNDfH"};